import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ProjectsFacade,
  getRolesAndPermission,
  getRolesAndPermissionForProject,
} from '@piqet-angular/data';
import { mainModuleName, rolesModuleName } from '@piqet-angular/shared';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Component({
  selector: 'piqet-angular-product-project-details',
  templateUrl: './product-project-details.component.html',
  styleUrls: ['./product-project-details.component.css'],
})
export class ProductProjectDetailsComponent {
  activatedRoute: any;
  productName: any;

  constructor(
    public route: ActivatedRoute,
    public projectFacade: ProjectsFacade,
    private sharedScrollService: SharedService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
  }

  ngOnInit(): void {
    this.sharedScrollService.scrollTriggered$.subscribe(() => {
      this.scrollToTop();
    });
  }

  handleName(event: any) {
    this.productName = event;
  }

  scrollToTop(): void {
    const parentElement = document.querySelector('.contentDiv');
    if (parentElement) {
      parentElement.scrollTop = 0;
    }
  }
}
